import React, { useEffect, useMemo, useState } from 'react';

import { getStoriesByBriefingId } from '../../../../services/storyService';
import { publishBriefing } from '../../../../services/briefingService';
import { selectUser } from '../../../../redux/reducers/userReducer';
import { useLoader } from '../../../../hooks/useLoader';
import { useSelector } from 'react-redux';

const PublishBriefing = ({ briefing, backPress }) => {
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [stories, setStories] = useState([]);

  const { showLoading } = useLoader();

  const user = useSelector(selectUser);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        showLoading(true);
        const result = await getStoriesByBriefingId({
          email: user.data?.user?.user_id || '',
          briefingId: briefing.id,
        });
        setStories(
          result?.data?.data?.stories?.filter(
            (item) => item.status !== 'rejected'
          ) ?? []
        );
        showLoading(false);
      } catch (error) {
        showLoading(false);
        console.log('🚀 ~ fetchStories ~ error:', error);
      }
    };
    fetchStories();
  }, []);

  const handlePublishClick = async (priorities: any[]) => {
    if (selectedItems.length !== stories.length) {
      alert('Please select all stories!!');
      return;
    }

    if (
      stories?.some((item) => item?.status !== 'approved') &&
      !window.confirm(
        'Are you sure want publish this briefing, There are some stories not approved?'
      )
    ) {
      return;
    }
    showLoading(true);

    try {
      const result = await publishBriefing({
        briefingId: briefing.id,
        priorities,
      });
      alert('Briefing published successfully!!');
      showLoading(false);
      backPress();
    } catch (error) {
      showLoading(false);
      if (error.response.data.message) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong");
      }
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    setSelectedItems((prevSelected: any) => {
      if (checked) {
        return [...prevSelected, value];
      } else {
        return prevSelected.filter((item) => item !== value);
      }
    });
  };

  // Sort the items alphabetically (you can modify this logic for other sorting)
  const itemsToBeRender = useMemo(() => {
    const output = [];
    for (const selectedId of selectedItems) {
      for (const element of stories) {
        if (selectedId === element.id) {
          output.push(element);
        }
      }
    }

    for (const element of stories) {
      if (!selectedItems.includes(element.id)) {
        output.push(element);
      }
    }

    return output;
  }, [stories, selectedItems]);

  return (
    <div>
      <div className='header-container'>
        <h2>Publish Briefing</h2>
        <span>
          <button
            className='save-a-Briefing'
            onClick={() => {
              backPress();
            }}
            style={{
              borderRadius: '100px',
              border: '1px solid #934848',
              color: '#934848',
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Close
          </button>
          <button
            className='save-a-Briefing'
            onClick={handlePublishClick.bind(this, itemsToBeRender)}
            style={{
              marginLeft: 10,
              backgroundColor: true ? '#0B335E' : '#8FA1B5',
              border: 'none',
              color: '#E7EBEF',
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Publish
          </button>
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {itemsToBeRender.map((item: any) => {
          const findIndex = selectedItems.findIndex((ele) => ele === item.id);
          const isChecked = findIndex > -1;
          return (
            <div
              key={item.id}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 10,
                }}
              >
                <input
                  type='checkbox'
                  value={item.id}
                  onChange={handleCheckboxChange}
                  checked={isChecked}
                  style={{
                    height: 20,
                    width: 20,
                  }}
                />

                <label
                  style={{
                    color: '#161616',
                    fontSize: 16,
                    fontFamily: 'Nunito Sans',
                    fontWeight: 700,
                    cursor: 'pointer',
                    marginLeft: 5,
                  }}
                >
                  {item.heading}
                  {isChecked ? `(${findIndex + 1}) ` : ''}
                </label>
              </div>
              <div
                style={{
                  color: '#161616',
                  fontSize: 12,
                  fontFamily: 'Nunito Sans',
                  fontWeight: 700,
                  cursor: 'pointer',
                  marginLeft: 30,
                }}
              >
                Auther: {item.email}
                <br />
                Status: {item.status}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PublishBriefing;
